/**
 * Thin API client. In SWA the Functions API is served under /api on the same
 * origin, so relative URLs work in dev (SWA CLI) and in production.
 */

export interface HealthResponse {
  status: 'ok';
  service: string;
  version: string;
  aiEnabled: boolean;
  transcriptionEnabled: boolean;
  time: string;
}

export async function getHealth(signal?: AbortSignal): Promise<HealthResponse> {
  const res = await fetch('/api/health', { signal });
  if (!res.ok) throw new Error(`Health check failed: ${res.status}`);
  return (await res.json()) as HealthResponse;
}
